export default "__VITE_ASSET__362a7f46__"